import { c as _c } from "react/compiler-runtime";
import { FontWeights, Text } from "@flat-ui";
import { Box } from "@mui-wrapper";
import FeedbackIntroIllustration from "@assets/illustrations/feedback-intro-illustration.svg?react";

/** Intro screen body shown before the survey starts */
export function AnalyticsFeedbackIntroBody() {
  const $ = _c(5);
  let t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      display: "flex",
      flexDirection: "column",
      gap: 2
    };
    t1 = <Text variant="heading20">Can you see how your workspace is really being used?</Text>;
    t2 = <Text variant="bodyM" color="text.secondary">We're rebuilding workspace analytics — data volume, who did what, and what's actually getting viewed and used. We know it doesn't show everything yet. That's exactly what we're fixing.</Text>;
    t3 = <FeedbackIntroIllustration />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Box sx={t0}>{t1}{t2}{t3}<Text variant="bodyM" color="text.secondary">Tell us what it has to get right.<Box component="span" sx={{
          fontWeight: FontWeights.Bold,
          color: "text.primary"
        }}>{" "}3 quick questions, about a minute.</Box></Text></Box>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}